// SPDX-License-Identifier: Apache-2.0
//copied from perun-x-chain-frontend

import { BrowserProvider } from "ethers";
import i18n from "i18next";

/**
 * Gets the Web3 provider that has to be connected to one of the given
 * networkIDs and requests an account.
 *
 * @param networkIDs - The IDs of the supported networks that MetaMask can be
 * connected to.
 * @returns - The Web3 Provider and the address of the provided account.
 * @throws - Error, if:
 * - Getting the Web3 Provider fails.
 * - MetaMask is not connected to one of the networkIDs.
 * - Requesting the accounts failed.
 */
export async function onboard(provider: BrowserProvider): Promise<{
  accounts: string[];
}> {
  console.log("Onboarding...");
  const cID = await provider.send("eth_chainId", []);
  console.log(cID);

  let accounts: string[] = [];
  try {
    await provider.send!("eth_requestAccounts", []).then((accs: string[]) => {
      accounts = accs;
      if (accounts.length === 0) {
        return Promise.reject("No accounts specified");
      }
    });
  } catch {
    throw new Error(i18n.t("rejectedAccountSelect"));
  }

  return { accounts };
}
